import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {ProfileResponse} from "../types/profile";
import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";


const clearUserData = () => {
    localStorage.removeItem(USER_LOCALSTORAGE_KEY);
    localStorage.removeItem('user_success');
    window.location.reload();
};

export const fetchProfileData = createAsyncThunk<ProfileResponse>(
    'profile/fetchProfileDate',
    async (_, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error('No token found in localStorage.');
            }

            const {token} = JSON.parse(authToken);

            const response = await axios.get<ProfileResponse>('/api/profile/info', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                if (error.response?.status === 401) {
                    clearUserData();
                } else {
                    console.error('Network error:', error.message);
                }
            }
            return thunkAPI.rejectWithValue('error');
        }
    }
);

